import React, { useEffect, useState } from "react";
import PricingSimulator from "./ListingComponent/DynamicPricing/PricingSimulator";
import { useSelector } from "react-redux";
import { commonService } from "../../utils/commonService";
import { apiCall } from "../../utils/axiosService";
import { API_URL } from "../../utils/apiRoutes";
import { errorToastMessage } from "../../utils/toastMessage";
import Loader from "../Loader/Loader";

const WhatIfPricingSimulator = ({ api, para, setting }) => {
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail,
  );

  const propertyCode = para?.propertyCode || para?.PropertyCode || para?.propertycode || propertyDetailFromRTK?.propertycode || "";
  const propertyId = para?.propertyId || para?.PropertyId || para?.propertyid || propertyDetailFromRTK?.propertyid || 0;

  const [asOfDate, setAsOfDate] = useState(null);
  const [loading, setLoading] = useState(api === 0 ? false : true);

  const getAsOfDate = async () => {
    if (api === 0) return;
    setLoading(true);
    let asOfDateResponse = await apiCall(
      {
        method: "POST",
        url: API_URL.BASE_API_URL.SnapShot + API_URL.AS_OF_DATE.AS_OF_DATE,
        body: { propertyCode: propertyCode },
      },
      false,
    );

    if (asOfDateResponse?.status_code === 0) {
      setLoading(false);
      return errorToastMessage(asOfDateResponse?.message);
    } else if (asOfDateResponse?.status_code === 1) {
      setAsOfDate(
        asOfDateResponse?.data?.[0]?.last_data_refresh
          ? asOfDateResponse?.data?.[0]?.last_data_refresh
          : `${commonService.getDateForNode(new Date())} 00:00:00`,
      );
      setLoading(false);
    }
  };

  useEffect(() => {
    if (api === 0) return;
    if (propertyCode) {
      getAsOfDate();
    }
  }, [propertyCode, api]);

  return (
    <div>
      {propertyCode ? (
        <>
          <h6>What-If Pricing Simulator</h6>
          {!loading && asOfDate ? (
            <PricingSimulator
              api={api}
              para={{
                propertyDetail: propertyDetailFromRTK,
                propertyCode: propertyCode,
                propertyId: propertyId,
                asOfDate: asOfDate,
                widgetId: para?.widgetId,
              }}
            />
          ) : (
            <>
              {loading ? (
                <Loader />
              ) : (
                <div className="d-flex justify-content-center p-5">
                  <p>No Data Found</p>
                </div>
              )}
            </>
          )}
        </>
      ) : (
        <div className="d-flex justify-content-center p-5">
          <h5>Please Select Property</h5>
        </div>
      )}
    </div>
  );
};

export default WhatIfPricingSimulator;
